import Box from "@mui/material/Box";
import Accessories from "app/containers/Quotes/components/QuotesDetails/OpenBoxQuotes/Accessories";
import BoxStructure from "app/containers/Quotes/components/QuotesDetails/OpenBoxQuotes/BoxStructure";
import QuoteCosts from "app/containers/Quotes/components/QuotesDetails/OpenBoxQuotes/QuoteCosts";
import QuoteFloor from "app/containers/Quotes/components/QuotesDetails/OpenBoxQuotes/QuoteFloor";
import Standard from "app/containers/Quotes/components/QuotesDetails/OpenBoxQuotes/Standard";
import { QuoteSummaryMetrics } from "app/containers/Quotes/components/QuotesDetails/OpenBoxQuotes/SummaryBar";
import ClosedBoxQuotes from "app/containers/Quotes/components/QuotesDetails/ClosedBoxQuotes";
import InsulatedBoxQuotes from "app/containers/Quotes/components/QuotesDetails/InsulatedBoxQuotes";
import RoofBoxCurtainsQuotes from "app/containers/Quotes/components/QuotesDetails/RoofBoxCurtainsQuotes";
import { selectQuoteDetails } from "app/containers/Quotes/redux/selector";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { CalculatePriceButton } from "app/components/Button/CalculatePriceButton";
import { CancelButton } from "app/components/Button/CancelButton";
import { selectWorkOrderVehicleDetails } from "../../../redux/selector";
import { getMockVehicleDetails } from "../data";
import { useStyles } from "./styles";

const OpenBoxQuotes = () => {
  const data = useSelector(selectQuoteDetails);

  return (
    <>
      <QuoteSummaryMetrics data={data} />
      <QuoteCosts />
      <QuoteFloor />
      <BoxStructure />
      <Accessories />
      <Standard />
    </>
  );
};

const Quotation = () => {
  const { i18n } = useTranslation();
  const styles = useStyles();
  const { id } = useParams();
  const vehicleDetails = useSelector(selectWorkOrderVehicleDetails);
  const boxType = (
    vehicleDetails ?? getMockVehicleDetails(Number(id))
  ).boxType;

  return (
    <Box className={styles.root} dir={i18n.dir()}>
      {boxType === "OPEN_BOX" ? <OpenBoxQuotes /> : null}
      {boxType === "CURTAIN_ROOF" ? <RoofBoxCurtainsQuotes /> : null}
      {boxType === "CLOSED_BOX" ? <ClosedBoxQuotes /> : null}
      {boxType === "REFRIGERATED" ? <InsulatedBoxQuotes /> : null}
      <Box className={styles.actionsRow}>
        <CalculatePriceButton />
        <CancelButton />
      </Box>
    </Box>
  );
};


export default Quotation;
